import type { TFunction } from "i18next";

import { z } from "zod";

export function createSyncsApplySchema(t: TFunction) {
  const syncSongListItemSchema = z.object({
    workcode: z.string().trim().min(1, t("regex:choose-work-error", "Please select a valid work.")),
    title: z.string(),
    performingartists: z.string().optional(),
    label: z.string().optional(),
  });

  return z.object({
    opp: z.string().min(1, t("regex:choose-sync-error", "Please choose a sync opportunity.")),
    songList: z
      .array(syncSongListItemSchema)
      .min(1, t("regex:add-at-least-one-song-error", "Please add at least one song.")),
    content: z.string().optional(),
  });
}

export type SyncsApplyFormData = z.infer<ReturnType<typeof createSyncsApplySchema>>;
